const getIsLoggedIn = (state) => state.auth.isLoggedIn;

const authSelectors = {
  getIsLoggedIn,
};

export default authSelectors;
